export const name = 'fullscreen';
